(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();

(function (Message) {
    'use strict';
    // ==================================================
    // Mensajes de error
    // ==================================================  
    Message.Error = {
        '500': "Internal Server Error",
        '400': "Bad Request",
        '401': "Unauthorized",
        '403': "Forbidden",
        '404': "Not Found",
        '405': "Method Not Allowed",
        'TIMEOUT': "Connection Timeout",
        'ABORT': "Aborted",
        'GENERAL': "Sucedió un error inesperado. Volvé a intentarlo más tarde.",
        'ENLACE_CADUCADO': "El link no se encuentra vigente."
  };

  Message.Analytics.Error = {
    '500': "Internal Server Error",
    '400': "Bad Request",
    '401': "Unauthorized",
    '403': "Forbidden",
    '404': "Not Found",
    '405': "Method Not Allowed",
    'TIMEOUT': "Connection Timeout",
    'ABORT': "Aborted",
    'GENERAL': "Sucedió un error inesperado. Volvé a intentarlo más tarde.",
    'ENLACE_CADUCADO': "El link no se encuentra vigente."
  };
    // ==================================================
    // Mensajes de error
    // ==================================================  
    Message.Usuario = {
        'CAPTCHA_INVALIDO': 'Captcha inválido',
        'CAPTCHA_REQUERIDO': 'Confirmá el captcha para poder continuar',
        'USUARIO_INVALIDO': 'Ingresá un e-mail o un usuario válido',
        'EMAIL_INVALIDO': 'Ingresá un e-mail válido',
        'CLAVE_INVALIDA': 'Ingresá una clave valida',
        'SUSPENDIDO_POR_ABUSO': 'Suspendido por abuso',
        'ELIMINADO_LOGICO': 'Eliminado Logico',
        'SUSPENDIDO_DEFINITIVO': 'Suspendido definitivo',
        'USUARIO_EXISTE_MAIL': 'Se produjo un error al enviar el mail al nuevo usuario registrado',
        'USUARIO_EXISTE': 'El usuario ya existe',
        'USUARIO_NO_EXISTE': 'El usuario no existe',
        'USUARIO_O_GUID_NO_EXISTE': 'El usuario o GUID no existe',
        'NO_ACTUALIZA': 'No se pudo actualizar',
        'LOGUEATE_RED_SOCIAL': 'El usuario ya esta registrado por redes sociales. Iniciá sesión con Google o Facebook.',
        //'LOGUEATE_RED_SOCIAL': 'Ese e-mail ya esta registrado por redes sociales. Iniciá sesión con Google o Facebook.',
        'NOMBRE_APELLIDO_INCORRECTO': 'Tenés que incluir al menos 2 caracteres sin números ni símbolos',
        'DOMINIO_INVALIDO': 'Dominio no permitido.',
        'FACEBOOK_EXISTE': 'Ya existe un usuario con el perfil de facebook ingresado.',
        'GMAIL_EXISTE': 'Ya existe un usuario con la cuenta de Google ingresada.',
        'CLAVE_ACTUAL_INVALIDA': 'La clave actual ingresada es incorrecta',
        'CLAVE_ANTERIOR_INVALIDA': 'Su clave anterior es incorrecta',
        'VOLVER_A_INTENTARLO': 'Volver a intentarlo',
        'USUARIO_DOMINIO_INVALIDO': 'El dominio está inhabilitado. Intentá con otro.',
        'USUARIO_CLAVE_REPETIDA': 'La nueva contraseña no puede ser igual a una contraseña utilizada previamente.',
        'USUARIO_CAMPO_FALTANTE': 'Debe completar todos los datos para darse de alta.',
        'ALTA_RED_INVALIDA': 'El usuario ya esta registrado o asociado por redes sociales.',
        'ALTA_MAIL_NO_ENVIO': 'Se produjo un error al enviar el mail al nuevo usuario registrado.',
        'CODIGO_INVALIDO': 'Codigo verificacion invalido.',
        'CARACTER_INVALIDO_MAIL': 'El E-mail no puede contener caracteres especiales.',
        'INFORMACION_NO_ENCONTRADA': 'Informacion del contacto no encontrada.',
        'CARACTER_INVALIDO_PASS_REG': 'Tu contraseña incluye caracteres especiales no permitidos. Intentá nuevamente evitando; acentos, ñ, comillas y otros símbolos.'
  };

  Message.Analytics.Usuario = {
    'CAPTCHA_INVALIDO': 'Captcha inválido',
    'CAPTCHA_REQUERIDO': 'Confirmá el captcha para poder continuar',
    'USUARIO_INVALIDO': 'Ingresá un e-mail o un usuario válido',
    'EMAIL_INVALIDO': 'Ingresá un e-mail válido',
    'CLAVE_INVALIDA': 'Ingresá una clave valida',
    'SUSPENDIDO_POR_ABUSO': 'Suspendido por abuso',
    'ELIMINADO_LOGICO': 'Eliminado Logico',
    'SUSPENDIDO_DEFINITIVO': 'Suspendido definitivo',
    'USUARIO_EXISTE_MAIL': 'Se produjo un error al enviar el mail al nuevo usuario registrado',
    'USUARIO_EXISTE': 'El usuario ya existe',
    'USUARIO_NO_EXISTE': 'El usuario no existe',
    'USUARIO_O_GUID_NO_EXISTE': 'El usuario o GUID no existe',
    'NO_ACTUALIZA': 'No se pudo actualizar',
    'LOGUEATE_RED_SOCIAL': 'El usuario ya esta registrado por redes sociales. Iniciá sesión con Google o Facebook.',
    //'LOGUEATE_RED_SOCIAL': 'Ese e-mail ya esta registrado por redes sociales. Iniciá sesión con Google o Facebook.',
    'NOMBRE_APELLIDO_INCORRECTO': 'Tenés que incluir al menos 2 caracteres sin números ni símbolos',
    'DOMINIO_INVALIDO': 'Dominio no permitido.',
    'FACEBOOK_EXISTE': 'Ya existe un usuario con el perfil de facebook ingresado.',
    'GMAIL_EXISTE': 'Ya existe un usuario con la cuenta de Google ingresada.',
    'CLAVE_ACTUAL_INVALIDA': 'La clave actual ingresada es incorrecta',
    'CLAVE_ANTERIOR_INVALIDA': 'Su clave anterior es incorrecta',
    'VOLVER_A_INTENTARLO': 'Volver a intentarlo',
    'USUARIO_DOMINIO_INVALIDO': 'El dominio está inhabilitado. Intentá con otro.',
    'USUARIO_CLAVE_REPETIDA': 'La nueva contraseña no puede ser igual a una contraseña utilizada previamente.',
    'USUARIO_CAMPO_FALTANTE': 'Debe completar todos los datos para darse de alta.',
    'ALTA_RED_INVALIDA': 'El usuario ya esta registrado o asociado por redes sociales.',
    'ALTA_MAIL_NO_ENVIO': 'Se produjo un error al enviar el mail al nuevo usuario registrado.',
    'CODIGO_INVALIDO': 'Codigo verificacion invalido.',
    'CARACTER_INVALIDO_MAIL': 'El E-mail no puede contener caracteres especiales.',
    'INFORMACION_NO_ENCONTRADA': 'Informacion del contacto no encontrada.',
    'CARACTER_INVALIDO_PASS_REG': 'Tu contraseña incluye caracteres especiales no permitidos. Intentá nuevamente evitando; acentos, ñ, comillas y otros símbolos.'
  };

    // ==================================================
    // Mensajes de error
    // ==================================================  
    Message.Credencial = {
        'ERROR_ASOCIAR': 'No se pudo vincular tu tarjeta. Volvé a intentar ingresando DNI y número de tarjeta de Club LA NACION. <br><br>' +
                         'Si el error persiste comunicata el <b>5199-4787</b> o desde el exterior a accesodigital@lanacion.com.ar <br>' +
                         'Horario de atención telefónica: Lunes a Viernes de 8 a 20hs. Sábados y Domingos de 8 a 14hs.',
        'ERROR_NO_COINCIDEN': 'Los números de DNI y Tarjeta que ingresaste no coinciden.  Cargalos nuevamente. <br> ¿Tenés dudas? Llamanos al <b>5199-4787</b> o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b> ',
        'ERROR_YA_ASOCIADO': 'La tarjeta está vinculada con el e-mail: <b>{{email}}</b> <br>' +
                             'Si es tuyo, ingresá con esa cuenta. <br><br>' +
                             'Sino llamanos al <b>5199-4787</b> o desde el exterior a accesodigital@lanacion.com.ar <br>' +
                             'Horario de atención telefónica: Lunes a Viernes de 8 a 20hs. Sábados y Domingos de 8 a 14hs. <br><br>' +
                             '<a href="https://goo.gl/K3gZWY" target="_blank">¿cómo desvincular la credencial para usarla en mi nueva cuenta?</a>',
        //'ERROR_YA_ASOCIADO_CORTO': 'Tu tarjeta está asociada a otro email. Para continuar, ingresá con esa cuenta.<br><br>' + 
        //                           '¿Tenés dudas? Llamanos al <b>5199-4787</b> o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b>',
        'ERROR_DEUDA': 'No podés asociar tu tarjeta porque tu cuenta registra una deuda con <b>LA NACION</b>.<br><br>' +
                        'Para continuar comunicate al <b>5199-4787</b> o desde el exterior a <b>accesodigital@lanacion.com.ar</b>',
        'DNI_INCOMPLETO': 'Revisá que el número de documento esté completo',
        'INCORRECTA': 'Tarjeta incorrecta',
        'INCORRECTA_ATTEMP': 'El número de tarjeta es incorrecto. Por favor, revisalo y volvé a ingresarlo.'
  }

  Message.Analytics.Credencial = {
    'ERROR_ASOCIAR': 'No se pudo vincular tu tarjeta. Volvé a intentar ingresando DNI y número de tarjeta de Club LA NACION. <br><br>' +
      'Si el error persiste comunicata el <b>5199-4787</b> o desde el exterior a accesodigital@lanacion.com.ar <br>' +
      'Horario de atención telefónica: Lunes a Viernes de 8 a 20hs. Sábados y Domingos de 8 a 14hs.',
    'ERROR_NO_COINCIDEN': 'Los números de DNI y Tarjeta que ingresaste no coinciden.  Cargalos nuevamente. <br> ¿Tenés dudas? Llamanos al <b>5199-4787</b> o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b> ',
    'ERROR_YA_ASOCIADO': 'La tarjeta está vinculada con el e-mail: <b>{{email}}</b> <br>' +
      'Si es tuyo, ingresá con esa cuenta. <br><br>' +
      'Sino llamanos al <b>5199-4787</b> o desde el exterior a accesodigital@lanacion.com.ar <br>' +
      'Horario de atención telefónica: Lunes a Viernes de 8 a 20hs. Sábados y Domingos de 8 a 14hs. <br><br>' +
      '<a href="https://goo.gl/K3gZWY" target="_blank">¿cómo desvincular la credencial para usarla en mi nueva cuenta?</a>',
    //'ERROR_YA_ASOCIADO_CORTO': 'Tu tarjeta está asociada a otro email. Para continuar, ingresá con esa cuenta.<br><br>' + 
    //                           '¿Tenés dudas? Llamanos al <b>5199-4787</b> o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b>',
    'ERROR_DEUDA': 'No podés asociar tu tarjeta porque tu cuenta registra una deuda con <b>LA NACION</b>.<br><br>' +
      'Para continuar comunicate al <b>5199-4787</b> o desde el exterior a <b>accesodigital@lanacion.com.ar</b>',
    'DNI_INCOMPLETO': 'Revisá que el número de documento esté completo',
    'INCORRECTA': 'Tarjeta incorrecta',
    'INCORRECTA_ATTEMP': 'El número de tarjeta es incorrecto. Por favor, revisalo y volvé a ingresarlo.'
  }

    Message.Pines = {
        'PIN_VENCIDO': 'El código de activación ha vencido. Por favor, comunicate al call center: 5199-4787',
        'PIN_USADO': 'El código de activación que ingresaste ya ha sido utilizado.',
        'PIN_INEXISTENTE': 'Código de Activación inválido.',
        'PIN_ASOCIADA': 'Tu cuenta de LA NACION ya tiene una tarjeta asociada. Para continuar, es necesario que desvincules esa tarjeta desde <a href="#" target="_blank" class="next-button" data-step="validar_pines_miclub">Mi Cuenta</a>. <br>' + 
                        'Luego podrás volver a cargar tu código de activación. <br> '+
                        'Sino podés activarlo con otra cuenta de LA NACION.',
        'PIN_ASOCIADA_BONIFICADO': 'Tenes una tarjeta asociada en tu cuenta de LA NACION que te permite tener acceso digital bonificado. <br> ' + 
                                   'No es necesario que utilices el código de activación. <br> ' +
                                   'Disfrutá del beneficio que te ofrece tu tarjeta {credencial} <a href="#" class="next-button"  data-step="validar_pines_tyc" >activándolo ahora</a>.',
        'PIN_SUSCRIPCION_ACTIVA': 'Tu cuenta de LA NACION ya tiene una suscripción digital activa. El código de activación podrás aplicarlo en otra cuenta diferente.',
        'PIN_ASOCIADO_A_OTRO_CRM': 'No hemos podido activar el PIN a tu usuario porque se encuentra asociado a otro cliente.<br><br> Te pedimos que por favor te comuniques al 5199-4787.<br> Muchas gracias!'
  }

  Message.Analytics.Pines = {
    'PIN_VENCIDO': 'El código de activación ha vencido. Por favor, comunicate al call center: 5199-4787',
    'PIN_USADO': 'El código de activación que ingresaste ya ha sido utilizado.',
    'PIN_INEXISTENTE': 'Código de Activación inválido.',
    'PIN_ASOCIADA': 'Tu cuenta de LA NACION ya tiene una tarjeta asociada. Para continuar, es necesario que desvincules esa tarjeta desde <a href="#" target="_blank" class="next-button" data-step="validar_pines_miclub">Mi Cuenta</a>. <br>' +
      'Luego podrás volver a cargar tu código de activación. <br> ' +
      'Sino podés activarlo con otra cuenta de LA NACION.',
    'PIN_ASOCIADA_BONIFICADO': 'Tenes una tarjeta asociada en tu cuenta de LA NACION que te permite tener acceso digital bonificado. <br> ' +
      'No es necesario que utilices el código de activación. <br> ' +
      'Disfrutá del beneficio que te ofrece tu tarjeta {credencial} <a href="#" class="next-button"  data-step="validar_pines_tyc" >activándolo ahora</a>.',
    'PIN_SUSCRIPCION_ACTIVA': 'Tu cuenta de LA NACION ya tiene una suscripción digital activa. El código de activación podrás aplicarlo en otra cuenta diferente.',
    'PIN_ASOCIADO_A_OTRO_CRM': 'No hemos podido activar el PIN a tu usuario porque se encuentra asociado a otro cliente.<br><br> Te pedimos que por favor te comuniques al 5199-4787.<br> Muchas gracias!'
  }

    Message.Pago = {
        'ERROR_CARGA': 'Ha ocurrido un error al procesar tu compra. Por favor, volvé a intentarlo nuevamente.',
        'SOLICITUD_VENCIDA': 'Has excedido el tiempo de compra. Por favor, volvé a ingresar los datos de la forma de pago.',
        'DATOS_INVALIDOS': 'Los datos ingresados no son correctos. Por favor, ingresalos nuevamente.',
        'ERROR_GENERAL': 'Ha ocurrido un error al procesar tu compra. Por favor, volvé a intentarlo nuevamente.'
  };

  Message.Analytics.Pago = {
    'ERROR_CARGA': 'Ha ocurrido un error al procesar tu compra. Por favor, volvé a intentarlo nuevamente.',
    'SOLICITUD_VENCIDA': 'Has excedido el tiempo de compra. Por favor, volvé a ingresar los datos de la forma de pago.',
    'DATOS_INVALIDOS': 'Los datos ingresados no son correctos. Por favor, ingresalos nuevamente.',
    'ERROR_GENERAL': 'Ha ocurrido un error al procesar tu compra. Por favor, volvé a intentarlo nuevamente.'
  };

})(LN.Message);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/message.js